import React, { useMemo, useCallback, useEffect } from 'react';
import TableContainer from '../../components/Common/TableContainer';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Button, Container } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { generateColumns } from '../../custom/Utils/ColumnUtils';
import useFetchData from '../../custom/Utils/UseFetchDataUtils';
import usePagination from '../../custom/Utils/UsePaginationUtils';
import { listPageData } from './VendorUserFile';
import { postData } from '../../services/api.service';
import { fetchVendorActionLogDetails } from '../../custom/Utils/vendorLogsUtils';

const VendorUserList = () => {
    const navigate = useNavigate();
    const { payload, navigatePage, headerName, columnData,searchFields } = listPageData();
    const initialPayload = useMemo(() => payload, []);

    // pagination
    const {
        page,
        pageSize,
        nextPage,
        previousPage,
        lastPage,
        firstPage,
        handlePageSizeChange,
        setPage,
    } = usePagination();

useEffect(() => {
    fetchVendorActionLogDetails('View - Vendor User List');
}, []);
    // fetch data using the provided payload, page, and page size
    const url = '/common/getRecords';
    const { data, isLoading, setSearchKeyword, totalCount } = useFetchData(
        initialPayload,
        page,
        pageSize,
        url,
        searchFields
    );
    // handle create action
    const handleCreate = async() =>{
        await fetchVendorActionLogDetails('Create -  Vendor User');
        navigate(navigatePage.create);
    } 

    // handle edit action
    const handleEdit = useCallback(
       async (id) => {
              await fetchVendorActionLogDetails('Edit - Vendor User', id);
            navigate(navigatePage.edit + '/' + id);
        },
        [navigate, navigatePage.edit]
    );
    const handleView = useCallback(
        async (id) => {
            await fetchVendorActionLogDetails('View - Vendor User', id);
            navigate(navigatePage.view + '/' + id);
        },
        [navigate, navigatePage.view]
    );

const columns = useMemo(
    () => [
        {
            Header: () => (
                <>
                    <div className='table-header-bold-extra'>Sr.No.</div>
                </>
            ),
            accessor: 'index',
            disableFilters: true,
            disableSortBy: true,
        },
        {
            Header: (
                <div className='table-header-bold-extra'>
                    E-Mail (Consider as Username)
                </div>
            ),
            accessor: 'email_id_68',
            disableFilters: true,
        },

        {
            Header: (
                <div className='table-header-bold-extra'>Mobile Number</div>
            ),
            accessor: 'mobile_no_67',
            disableFilters: true,
            Cell: ({ value }) => (value ? value : 'NA'),
        },
        {
            Header: <div className='table-header-bold-extra'>Name</div>,
            accessor: 'name_66',
            disableFilters: true,
        },
        {
            Header: <div className='table-header-bold-extra'>Is Active</div>,
            accessor: 'is_active_157',
            disableFilters: true,
            Cell: ({ value }) => {
                if (value === 'Active' || value === false || value === 0) {
                    return 'Inactive';
                }
                return 'Active';
            },
        },

        {
            Header: () => <div className='table-header-bold-extra'>Action</div>,
            accessor: 'actions',
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row }) => (
                <>
                    <Button
                        color='primary'
                        onClick={() => {
                            handleEdit(row.original.id);
                        }}
                    >
                        <i className='fas fa-edit'></i>
                    </Button>{' '}
                    <Button
                        color='primary'
                        onClick={() => handleView(row.original.id)}
                    >
                        <i className='fas fa-eye'></i>
                    </Button>
                </>
            ),
        },
    ],
    [data]
);
    // handle page size change callback
    const handlePageSizeChangeWrapper = useCallback(
        (newSize) => {
            if (newSize !== pageSize) {
                handlePageSizeChange(newSize, totalCount);
                setPage(0); // Reset to first page when page size changes
            }
        },
        [handlePageSizeChange, pageSize, totalCount, setPage]
    );

    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                        }}
                    >
                        <Breadcrumbs title={headerName} breadcrumbItems={[]} />
                        <Button
                            color='primary'
                            className='waves-effect waves-light me-1 bold-button'
                            onClick={handleCreate}
                            style={{ marginLeft: 'auto' }}
                        >
                            + Add New {headerName}
                        </Button>
                    </div>

                    <Card>
                        <CardBody>
                            <TableContainer
                                columns={columns || []}
                                data={data || []}
                                isLoading={isLoading}
                                onSearchInputData={setSearchKeyword}
                                pageIndexProp={page}
                                onPageSizeChange={handlePageSizeChangeWrapper}
                                nextToPage={nextPage}
                                lastToPage={() => lastPage(totalCount)}
                                previousToPage={previousPage}
                                previousFirstToPage={firstPage}
                                totalCount={totalCount}
                                customPageSize={pageSize}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default VendorUserList;
